<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To my Granda Kenny and my Granny Hazel, for always<br/>
feeding my imagination.</p><br/>
<p style="text-align: center;">Also dedicated to my late Granny Florence, who never stopped<br/>
believing in me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1dc42852